enum ApplicationAttribute {
  Application = 'application',
  ApplicationId = 'applicationId',
  ApplicationDisplayId = 'applicationDisplayId',
}

export default ApplicationAttribute;
